import React, { useState } from 'react';
import styled from 'styled-components';

const StyledAdmin = styled.div`
    max-width: 800px;
    margin: 0 auto;
    font-size: 1.1em;
    font-weight: bold;
    #search-grid {
        display: grid;
        grid-template: 1fr / 1fr 150px;
        grid-gap: 2px;
        background-color: #bfbfbf;
        padding: 2px;
    }
    #attr-grid {
        display: grid;
        grid-template: 1fr / 1fr 150px;
        grid-gap: 2px;
        background-color: #bfbfbf;
        padding: 2px;
    }
    .button {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .title {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 10px;
        background-color: white;
    }
    .admin {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        background-color: white;
        
    }
    #check {
        margin-left: 10px;
    }
    #layout-grid {
        background-color: #bfbfbf;
        display: grid;
        grid-template: 1fr 1fr / 150px 1fr 150px;
        grid-gap: 2px;
        align-items: center;
        padding 2px 
    }
    .height {
        min-height: 40px;
    }
    #id, #email {
        padding: 0 10px;
    }
    .display {
        display: flex;
        align-items: center;
        padding: 0 10px;
    }
    .email-disp {
        background-color: #dcdcdc;
    }
    
    .not-allowed {
        cursor: not-allowed;
    }
    [loaded="val"] .not-allowed {
        cursor: pointer;
    }
    #id {
        pointer-events: none;
        width: 100%;
        outline: none;
        border: none;
    }
    [loaded="val"] #id {
        pointer-events: auto;
    }
    #check {
        pointer-events: none;
    }
    [loaded="val"] #check {
        pointer-events: auto;
    }
    .delete {
        background-color: gray;
        color: white;
        pointer-events: none;
    }
    .search {
        background-color: gray;
        color: white;
        pointer-events: none;
    }
    .update {
        background-color: gray;
        color: white;
        pointer-events: none;
    }
    [loaded="val"] .delete {
        background-color: red;
        pointer-events: auto;
        cursor: pointer;
    }
    [search="val"] .search {
        background-color: green;
        pointer-events: auto;
        cursor: pointer;
    }
    [update="val"] .update {
        background-color: green;
        pointer-events: auto;
        cursor: pointer;
    }
    .delete {
        
    }
`;  

export default function SearchPage(props) {
    const userState = {
        message: '',
        searchInput: '',
        emailInput: '',
        id: '',
        idInput: '',
        adminInput: false,
        admin: false
    };
    
    const [user, setUser] = useState(userState);
    
    async function callUser(method, body) {
        const url = `/user`;
        const opts = {
            method,
            body: JSON.stringify(body),
            headers: {
                'Authorization': `Bearer ${props.creds.signInUserSession.idToken.jwtToken}`
            }
        };
        const user_response = await fetch(url, opts);
        const res = await user_response.json();
        return res;
    }
    
    function onSearchInputChange(e) {
        setUser({...user, searchInput: e.target.value, message:''});
    }
    
    function onIdInputChange(e) {
        setUser({...user, idInput: e.target.value, message:''});
    }
    
    function onCheckChange(e) {
        setUser({...user, adminInput: e.target.checked, message:''});
    }
    
    async function onSearch() {
        try {
            let userInfo = await callUser('POST', {"user":user.searchInput});
            if (userInfo.hasOwnProperty('email') && userInfo.hasOwnProperty('id')) {
                setUser({
                    ...user,
                    id: userInfo.id,
                    idInput: userInfo.id,
                    admin: (userInfo.admin === "true"),
                    adminInput: (userInfo.admin === "true"),
                    message: userInfo.message,
                    emailInput: userInfo.email,
                    searchInput: ''
                });
            } else {
                setUser({
                    ...user,
                    message: (userInfo.message === 'The incoming token has expired') ? 'Your session has expired - Please refresh the page.' : userInfo.message,
                });
            }
        } catch(err) {
            console.log('User endpoit search faild', err);
            setUser({
                ...user,
                message: 'Connection to server failed',
            });
        }
    }
    
    async function onUpdate() {
        try {
            const atts = {
                "user": user.emailInput,
                "clientId": user.idInput,
                "admin": user.adminInput.toString()
            };
            const userInfo = await callUser('PUT', atts);
            setUser({
                ...user,
                message: userInfo.message,
                id: user.idInput,
                admin: user.adminInput
            });
        } catch(err) {
            console.log('User endpoit update faild', err);
            setUser({
                ...user,
                message: 'Connection to server failed',
            });
        }
    }
    
    async function onDelete() {
        try {
            const userInfo = await callUser('DELETE', {"user": user.emailInput}) ;
            setUser({
                ...user,
                message: userInfo.message,
                id: '',
                idInput: '',
                emailInput: '',
                admin: false,
                adminInput: false
            });
        } catch(err) {
            console.log('User endpoit delete faild', err);
            setUser({
                ...user,
                message: 'Connection to server failed',
            });
        }
    }
    
    function emailIsValid (email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
    
    return (
        <StyledAdmin>
        <br></br>
        <br></br>
        <div search={(emailIsValid(user.searchInput)) ? 'val' : ''}
             update={(user.admin !== user.adminInput || user.id !== user.idInput) ? 'val' : ''}
             loaded={(emailIsValid(user.emailInput)) ? 'val' : ''}>
            <div id="search-grid">
                <input onChange={onSearchInputChange} class="height" id="email" value={user.searchInput} type="email"></input>
                <div className={(emailIsValid(user.searchInput)) ? 'not-allowed' : ''}><div class="button height search" onClick={onSearch}>Search</div></div>
            </div>
            <br></br>
            <div id="layout-grid">
                <div>
                    <div class="title height">User Email:</div>
                </div>
                <div>
                    <div class="height display email-disp">{user.emailInput}</div>
                </div>
                <div class="not-allowed">
                    <div class="button height delete" onClick={onDelete}>Delete User</div>
                </div>
                <div>
                    <div class="title height">User ID:</div>
                </div>
                <div>
                    <div id="attr-grid">
                        <div class="not-allowed">
                            <input id="id" class="height" onChange={onIdInputChange} value={user.idInput} type="text"></input>
                        </div>
                        <div class="height admin not-allowed">
                            admin:
                            <input class="not-allowed" onChange={onCheckChange} id="check" type="checkbox" checked={user.adminInput}></input>
                        </div>
                    </div>
                </div>
                <div class="not-allowed">
                    <div class="button height update" onClick={onUpdate}>Update User</div>
                </div>
            </div>
            <div class="messgae-box height display">{user.message}</div>
        </div>    
        </StyledAdmin>
    );
}
